import React from 'react'
import brandImg from '@public/images/qct/brand.png'
import heroDesktop from '@public/images/qct/hero-desktop.jpg'
import heroMobile from '@public/images/qct/hero-mobile.jpg'

function App() {
  return (
    <div className="qct-recruit">
      <header className="site-header">
        <div className="header-inner">
          <img className="brand" src={brandImg} alt="青岛财通集团" />
          <nav className="tabs" aria-label="招聘页面">
            <a className="tab active" href="index.html" aria-selected="true">招聘公告</a>
            <a className="tab" href="job.html" aria-selected="false">招聘职位</a>
          </nav>
        </div>
      </header>
      <div className="hero desktop-hero">
        <img src={heroDesktop} alt="财华横溢，共通未来，青岛财通集团2026招聘" />
      </div>
      <div className="hero mobile-hero">
        <img src={heroMobile} alt="财华横溢，共通未来，青岛财通集团2026招聘" />
      </div>
      <nav className="tabs mobile-tabs" aria-label="招聘页面">
        <a className="tab active" href="index.html" aria-selected="true">招聘公告</a>
        <a className="tab" href="job.html" aria-selected="false">招聘职位</a>
      </nav>
      <main>
        <section className="page active" id="notice" aria-label="招聘公告">

      <div className="content-shell">
        <article className="notice-panel">
            <header className="notice-title">
              <h2>青岛财通集团有限公司</h2>
              <p>2026年招聘公告</p>
            </header>
            <div className="notice-content">
  <p>青岛财通集团有限公司（以下简称财通集团）于2020年9月22日成立，是经青岛市人民政府批准成立的市直金融类企业，由青岛市财政局代表青岛市人民政府履行出资人职责，注册资本金100亿元。</p>
  <p>财通集团致力于落实市委市政府重大战略部署，打造具有区域影响力的国有金融投资运营公司，聚焦现代金融服务领域，按照政策性业务和市场化业务“双轮驱动”的理念，构建以“基金管理、产业投资、金融服务”为核心、“资产运营、咨询设计”为基础的“三核两基”业务体系，为城市发展提供社会满意的产业培育和金融服务。</p>

  <h3 className="article-heading" id="company">一、招聘单位简介</h3>
  <p className="article-subheading">（一）青岛财通资产管理有限责任公司</p>
  <p>青岛财通资产管理有限责任公司（以下简称资管公司）是财通集团全资子公司。公司立足资产管理与运营的功能定位，是政府资产资源的“专业管家”。主要从事政策类资产运营及市场化金融资产管理等业务，聚焦整合各类政府资产资源及市场化不良债权资产，开展资产管理运营工作。青岛财通海达资产运营服务有限公司（以下简称海达公司）为资管公司全资子公司，拟开展全市特殊政策性资产接收、保管、处置综合服务工作。</p>
  <p className="article-subheading">（二）青岛市创新投资有限公司</p>
  <p>青岛市创新投资有限公司（以下简称创投公司）是财通集团全资子公司。主要从事政府引导基金管理及私募股权投资等投资和基金管理业务。公司以“汇富育新”为使命，与投资机构和创新企业共创基业，致力于成为引领资源要素、赋能实体经济的卓越生态平台。公司持续推进培育创投风投生态的“十个一”工程，打造“初心青创”党建品牌，获评“全国青年文明号”，连续多年被业内权威机构评为中国最佳政府引导基金管理机构。青岛青创财智投资有限公司（以下简称青创财智公司）为创投公司全资子公司，主要从事股权投资等投资业务。</p>
  <p className="article-subheading">（三）青岛财通融资租赁有限公司</p>
  <p>青岛财通融资租赁有限公司是财通集团全资子公司，公司积极开展交通装备领域融资租赁业务，同时持续开拓传统产业改造升级、战略性新兴产业和先进制造业领域优势产业的直租与售后回租业务，致力于成为数智化引领、产融深度融合、具有区域影响力的创新型融资租赁公司。</p>
  <p className="article-subheading">（四）青岛财通汇金投资有限公司</p>
  <p>青岛财通汇金投资有限公司是财通集团全资子公司，是青岛市应急引导基金的专属运营管理平台，主要从事应急引导基金管理及配套服务等业务。公司以降低企业资金周转成本、引导金融机构加大对企业支持力度为使命，致力于成为赋能实体经济、优化营商环境的专业运营平台。</p>

  <h3 className="article-heading" id="positions">二、招聘岗位</h3>
  <p className="article-subheading">（一）青岛财通资产管理有限责任公司14人</p>
  <p><strong>1.社会招聘5人：</strong>资产管理岗1人、法务管理岗1人、劳动关系岗1人、海达公司资产管理岗2人。</p>
  <p><strong>2.2026届毕业生9人：</strong>审计管理岗1人、财务管理岗1人、后勤管理岗1人、信息技术岗1人，海达公司业务管理岗2人、运营管理岗2人、综合管理岗1人。</p>
  <p className="article-subheading">（二）青岛市创新投资有限公司2人</p>
  <p><strong>社会招聘2人：</strong>投资管理岗1人、青创财智公司投资管理岗1人。</p>
  <p className="article-subheading">（三）青岛财通融资租赁有限公司1人</p>
  <p><strong>社会招聘1人：</strong>业务管理岗1人。</p>
  <p className="article-subheading">（四）青岛财通汇金投资有限公司8人</p>
  <p><strong>社会招聘3人：</strong>副总经理1人、主管会计岗1人、债权业务岗1人。</p>
  <p><strong>2026届毕业生5人：</strong>业务管理岗1人、风控管理岗1人、资金管理岗1人、融资管理岗1人、综合管理岗1人。</p>

  <h3 className="article-heading" id="application">三、报名方法</h3>
  <p><strong>一.报名时间：</strong>2026年9月15日-9月24日17时。</p>
  <p><strong>二.报名方式：</strong>通过猎聘网投递简历（https://www.liepin.com/company/12586571/）</p>
  <p><strong>三.报名材料：</strong></p>
  <p><strong>社会招聘：</strong>身份证、学历学位资格证书、职业资格证书等。</p>
  <p><strong>2026届毕业生：</strong>学校就业推荐表、在校期间学习成绩单、英语四六级证书、各类获奖证书、资格证书及其他应聘材料等扫描件；留学归国人员另需提交教育部出具的《国外学位学历认证书》电子版；研究生及以上学历人员，需提供本科在校期间学习成绩单和学历证书扫描件。国（境）内院校最高学历毕业时间为2025年8月1日至2026年7月31日；国（境）外院校毕业生须于2026年7月31日前取得教育部学历学位认证。</p>
  <p><strong>（四）资格审查。</strong>根据招聘岗位描述和资格要求，对应聘人员进行资格审查，资格审查贯穿公开招聘全过程，一经发现应聘人员不符合资格条件，即取消应聘资格。</p>

  <h3 className="article-heading" id="delivery-time">四、简历投递时间</h3>
  <p>2026年9月15日-9月24日17时</p>

  <h3 className="article-heading" id="notes">五、注意事项</h3>
  <p>（一）应聘者须对报名信息的真实性和准确性负责，凡弄虚作假者，一经核实，取消应聘资格。</p>
  <p>（二）招聘职位工作地点在青岛市。一经录用，按照相关法律规定签订劳动合同。</p></div>
        </article>
      </div>
    
        </section>
      </main>
    </div>
  )
}

export default App
